const themes = [
    { id: "research", name: "National research capacity and infrastructure" },
    { id: "spending", name: "Ocean science spending" },
    { id: "general", name: "Ocean science governmental organization and general information" },
    { id: "data", name: "Oceanographic data and information exchange" },
    { id: "capacity", name: "Capacity development and transfer of marine technology" },
    { id: "sustainable", name: "Sustainable development" }
];

export default themes;